import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Login from "./pages/Login";
import Register from "./pages/Register";
import EsqueciSenha from "./pages/EsqueciSenha";
import ResetarSenha from "./pages/ResetarSenha";
import Dashboard from "./pages/Dashboard";
import Lancamentos from "./pages/Lancamentos";
import Ranking from "./pages/Ranking";
import Relatorios from "./pages/Relatorios";
import Usuarios from "./pages/Usuarios";
import MinhaRede from "./pages/MinhaRede";
import Perfil from "./pages/Perfil";
import DetalheRede from "./pages/DetalheRede";
import FinanceiroPessoal from "./pages/FinanceiroPessoal";
import ControleCreditos from "./pages/ControleCreditos";
import Chat from "./pages/Chat";
import PainelChatSDVision from "./pages/PainelChatSDVision";
import AdminPanel from "./pages/AdminPanel";
import TopGestor from "./pages/TopGestor";
import MainLayout from "./layouts/MainLayout";

import { getToken } from "./utils/auth";

function PrivateRoute({ children }) {
  const token = getToken();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

function PublicRoute({ children }) {
  const token = getToken();

  if (token) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />

        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />

        <Route
          path="/esqueci-senha"
          element={
            <PublicRoute>
              <EsqueciSenha />
            </PublicRoute>
          }
        />

        <Route
          path="/resetar-senha"
          element={
            <PublicRoute>
              <ResetarSenha />
            </PublicRoute>
          }
        />

        <Route
          path="/register"
          element={
            <PublicRoute>
              <Register />
            </PublicRoute>
          }
        />

        <Route
          path="/cadastro"
          element={
            <PublicRoute>
              <Register />
            </PublicRoute>
          }
        />

        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <MainLayout>
                <Dashboard />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/lancamentos"
          element={
            <PrivateRoute>
              <MainLayout>
                <Lancamentos />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/relatorios"
          element={
            <PrivateRoute>
              <MainLayout>
                <Relatorios />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/ranking"
          element={
            <PrivateRoute>
              <MainLayout>
                <Ranking />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/usuarios"
          element={
            <PrivateRoute>
              <MainLayout>
                <Usuarios />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/minha-rede"
          element={
            <PrivateRoute>
              <MainLayout>
                <MinhaRede />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/minha-rede/:id"
          element={
            <PrivateRoute>
              <MainLayout>
                <DetalheRede />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/perfil"
          element={
            <PrivateRoute>
              <MainLayout>
                <Perfil />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/financeiro-pessoal"
          element={
            <PrivateRoute>
              <MainLayout>
                <FinanceiroPessoal />
              </MainLayout>
            </PrivateRoute>
          }
        />
<Route
  path="/controle-creditos"
  element={
    <PrivateRoute>
      <MainLayout>
        <ControleCreditos />
      </MainLayout>
    </PrivateRoute>
  }
/>
        <Route path="/chat" element={<PrivateRoute><MainLayout><Chat /></MainLayout></PrivateRoute>} />
        <Route path="/chat-sdvision" element={<PrivateRoute><MainLayout><PainelChatSDVision /></MainLayout></PrivateRoute>} />
        <Route path="/top-gestor" element={<PrivateRoute><MainLayout><TopGestor /></MainLayout></PrivateRoute>} />
        <Route path="/admin/*" element={<PrivateRoute><AdminPanel /></PrivateRoute>} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
